import React from 'react'

const Spacer = (props) => {
    let spacer = [];

    switch (props.size) {
        case "small":
            for (let i=0; i < props.quantity; i=(i+1)|0) {
                spacer.push(<div className="module-spacer--small module-spacer--color-light"></div>)
            }
            break;
        case "medium":
            for (let i=0; i < props.quantity; i=(i+1)|0) {
                spacer.push(<div className="module-spacer--medium module-spacer--color-light"></div>)
            }
            break;
        default:
            break;
    }

    return (
        <section className="module-spacer">
            {spacer}
        </section>
    )
};

export default Spacer
